import { render, staticRenderFns } from "./Individual-coporation-modal.vue?vue&type=template&id=566e9330"
import script from "./Individual-coporation-modal.vue?vue&type=script&lang=js"
export * from "./Individual-coporation-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports